import { OnInit, OnDestroy, Directive } from '@angular/core';
import {Subscription} from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
@Directive()
export class ComponentBase implements OnInit, OnDestroy {
  protected _subscriptions: Subscription[] = [];
  private _isCareCentralPage = new BehaviorSubject<boolean>(false);
  public isCareCentralPage$ = this._isCareCentralPage.asObservable();

  constructor(protected router?: Router) {
    this._subscriptions.push(
      this.router?.events?.subscribe(() => {
        const isCareCentral = this.router.url.includes('/main/care-central');
        this._isCareCentralPage.next(isCareCentral);
      })
    );
  }

  ngOnDestroy() {
    this.clearAllSubscriptions();
  }

  clearAllSubscriptions() {
    this._subscriptions.forEach(subscription => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
    this._subscriptions = [];
  }

  ngOnInit() {
    // Add initialisation related logic
  }
}
